module.exports = __webpack_public_path__ + "static/media/DISMORFOBIA.fd9e84b9.png";